// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"494d5d6c","507":"142be416"}[chunkId] + ".chunk.js";
};